export default __webpack_public_path__ + "2b8a0b82e3ef88e5b44555b8f0073fe8.jpg";